module.exports = __webpack_public_path__ + "img/ava-8.a0081022.webp";